<template>
    <div class="flat-index">
        <div class="fi-mobile">
            <fi-header-mobile :is-mark="oMark"></fi-header-mobile>
            <div class="aboutus-mobile">
                <div class="item">
                    <div class="ab-title">
                        <h1>01</h1>
                        <div class="ab-text">
                            <h2>关于点点</h2>
                            <p>About D.Point</p>
                        </div>
                    </div>
                    <div class="ab-content">
                        <p>
                            点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务。已与国内众多知名金融机构达成深度合作。
                        </p>
                    </div>
                </div>
                <div class="item">
                    <div class="ab-title">
                        <h1>02</h1>
                        <div class="ab-text">
                            <h2>点点大事记</h2>
                            <p>Events Of D.Point</p>
                        </div>
                    </div>
                    <div class="dd-record">
                        <ul>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2017.08.16</p>
                                </div>
                                <div class="dr-r">
                                    <p>点点APP上线</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2017.08.25</p>
                                </div>
                                <div class="dr-r">
                                    <p>上线9天单日放款金额超100万</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2017.11.27</p>
                                </div>
                                <div class="dr-r">
                                    <p>点点APP用户破百万</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2017.12.21</p>
                                </div>
                                <div class="dr-r">
                                    <p>上线120天用户破200万</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2018.03.20</p>
                                </div>
                                <div class="dr-r">
                                    <p>点点商城上线，甄选正品好货</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2018.04.28</p>
                                </div>
                                <div class="dr-r">
                                    <p>点点与中国银联达成战略合作，闪付功能上线</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2018.06.25</p>
                                </div>
                                <div class="dr-r">
                                    <p>点点2.0版本全新上线</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2018.07.10</p>
                                </div>
                                <div class="dr-r">
                                    <p>点点APP用户破1000万</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>2018.08.01</p>
                                </div>
                                <div class="dr-r">
                                    <p>生活缴费功能上线</p>
                                </div>
                            </li>
                            <li class="clearfix">
                                <div class="dr-l">
                                    <p>至今</p>
                                </div>
                                <div class="dr-r">
                                    <p>我们还在持续优化功能体验</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="item">
                    <div class="ab-title">
                        <h1>03</h1>
                        <div class="ab-text">
                            <h2>点点愿景·一站式金融生活服务平台</h2>
                            <p>About Future·A One-stop Financial Service Platform</p>
                        </div>
                    </div>
                    <div class="ab-icon">
                        <ul>
                            <li>
                                <div class="ad-pt">
                                    <i></i>
                                    <p>金融</p>
                                </div>
                                <div class="ad-pt">
                                    <i></i>
                                    <p>商城</p>
                                </div>
                                <div class="ad-pt">
                                    <i></i>
                                    <p>生活服务</p>
                                </div>
                            </li>
                            <li>
                                <div class="ad-pt">
                                    <i></i>
                                    <p>充值缴费</p>
                                </div>
                                <div class="ad-pt">
                                    <i></i>
                                    <p>休闲娱乐</p>
                                </div>
                                <div class="ad-pt">
                                    <i></i>
                                    <p>线下服务</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <fi-footer-mobile></fi-footer-mobile>
            <fi-mark :is-mark="oMark"></fi-mark>
        </div>
    </div>
</template>
<script>
    import {
        os
    } from '../utils/tool'
    import FiMark from '../components/fimark'
    import FiFooterMobile from '../components/footerMobile'
    import FiHeaderMobile from '../components/headerMobile'

    export default {
        components: {
            FiMark,
            FiFooterMobile,
            FiHeaderMobile
        },
        data() {
            const _vue = this;
            return {
                isPc: false,
                isMobile: false,
                oMark: {
                    show: false
                },
            }
        },
        mounted() {

        },
        methods: {
            hideMarkHandle(val) {
                thibs.isShow = val
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AboutUsMobile.vue?2915926c